import * as types from './types';
import _ from 'lodash';

const INITIAL_STATE = {
  basicSetup: {
    GetData: [],
    Data: [],
    Errors: [],
  },
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.BASICSETUP_GET:
      return {
        ...state,
        basicSetup: {
          ...state.basicSetup,
          GetData: action.payload.data.Data,
          Errors: [],
        },
      };

    case types.BASICSETUP_ERROR:
      if (_.has(action.payload, 'data.Errors')) {
        return {
          ...state,
          basicSetup: {
            ...state.basicSetup,
            Errors: action.payload.data.Errors,
          },
        };
      }

      const Errors = [
        {
          Title: 'Error',
          Message:
            'An error occurred while fetching information. Please try again',
        },
      ];

      return {
        ...state,
        basicSetup: {
          ...state.basicSetup,
          Errors,
        },
      };

    case types.BASICSETUP_CLEAR:
      return {
        basicSetup: {
          GetData: [],
          Data: [],
          Errors: [],
        },
        loading: false,
      };

    case types.BASICSETUP_UPDATE_COLLECTION:
      const newData = _.cloneDeep(state.basicSetup.Data);
      const item = _.find(newData, { Id: action.payload.Id });

      if (item === undefined) {
        return state;
      }

      item.IsLicensed = !action.payload.IsLicensed;

      return {
        ...state,
        basicSetup: {
          ...state.basicSetup,
          Data: newData,
          Errors: [],
        },
      };

    case types.BASICSETUP_LOADING:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/basicsetup/state/reducer.js